<template>
  <div style="padding: 10px">
    <el-form ref="form" :model="form" label-width="120px" size="small">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>基础信息</span>
        </div>
        <slot name="form-item-decision-name" :model="form" field="name">
          <el-form-item label="名称">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
        </slot>
        <slot name="form-item-decision-expr" :model="form" field="expr">
          <el-form-item label="决策表达式">
            <el-input v-model="form.expr"></el-input>
          </el-form-item>
        </slot>
<!--        <slot name="form-item-decision-handleClass" :model="form" field="handleClass">-->
<!--          <el-form-item label="处理类">-->
<!--            <el-input v-model="form.handleClass"></el-input>-->
<!--          </el-form-item>-->
<!--        </slot>-->
<!--        <slot name="form-item-decision-preInterceptors" :model="form" field="preInterceptors">-->
<!--          <el-form-item label="前置拦截器">-->
<!--            <el-input v-model="form.preInterceptors"></el-input>-->
<!--          </el-form-item>-->
<!--        </slot>-->
<!--        <slot name="form-item-decision-postInterceptors" :model="form" field="postInterceptors">-->
<!--          <el-form-item label="后置拦截器">-->
<!--            <el-input v-model="form.postInterceptors"></el-input>-->
<!--          </el-form-item>-->
<!--        </slot>-->
      </el-card>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      form: this.value
    }
  },
  watch: {
    form: {
      handler (n) {
        this.$emit('change', n)
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.box-card{
  border-radius: 8px;
  margin-bottom: 20px;
}
.clearfix{
  font-size: 16px;
  font-weight: bold;
}
</style>
